// import { useState, useEffect } from "react";
// import { DateRange } from "react-date-range";
// import { addDays, isWithinInterval } from "date-fns";
// import axios from "axios";
// import { useParams } from "react-router-dom";

// import "react-date-range/dist/styles.css";
// import "react-date-range/dist/theme/default.css";
// const formatDate = (d) => d.toISOString().split("T")[0];



// export default function BookingPage() {
//   const { roomId } = useParams();
//   const userId = localStorage.getItem("userId");



//   const [selection, setSelection] = useState([
//     {
//       startDate: new Date(),
//       endDate: addDays(new Date(), 1),
//       key: "selection",
//     },
//   ]);

//   const [bookedDates, setBookedDates] = useState([]);
//   const [isAvailable, setIsAvailable] = useState(null);
//   const [message, setMessage] = useState("");

//   // ----------------------------------------------------
//   // LOAD BOOKED DATES
//   // ----------------------------------------------------
//   useEffect(() => {
//     axios
//       .get(`http://localhost:8080/api/booking/room/${roomId}`)
//       .then((res) => {
//         setBookedDates(
//           res.data.map((b) => ({
//             start: new Date(b.checkIn),
//             end: new Date(b.checkOut),
//           }))
//         );
//       })
//       .catch((err) => console.error("Booked dates load error", err));
//   }, [roomId]);

//   // ----------------------------------------------------
//   // CHECK DATE OVERLAP
//   // ----------------------------------------------------
//   const isDateBooked = (date) => {
//     return bookedDates.some((range) =>
//       isWithinInterval(date, { start: range.start, end: range.end })
//     );
//   };

//   // ----------------------------------------------------
//   // CHECK AVAILABILITY
//   // ----------------------------------------------------
//   const checkAvailability = async () => {
//     if (!userId) {
//       alert("Please Login First");
//       return;
//     }

//     // const body = {
//     //   roomId: Number(roomId),
//     //   userId: Number(userId),
//     //   checkIn: selection[0].startDate,
//     //   checkOut: selection[0].endDate,
//     // };

//     const body = {
//   roomId: Number(roomId),
//   userId: Number(userId),
//   checkIn: formatDate(selection[0].startDate),
//   checkOut: formatDate(selection[0].endDate),
// };



//     try {
//       const res = await axios.post(
//         "http://localhost:8080/api/booking/check",
//         body
//       );

//       setIsAvailable(res.data);
//       setMessage(res.data ? "Room is available ✔" : "Room is NOT available ❌");
//     } catch (e) {
//       console.error(e);
//       setMessage("Error checking availability");
//     }
//   };

//   // ----------------------------------------------------
//   // BOOK ROOM
//   // ----------------------------------------------------
//   const bookRoom = async () => {
//     if (!userId) {
//       alert("Please login first!");
//       return;
//     }

//     // const body = {
//     //   roomId: Number(roomId),
//     //   userId: Number(userId),
//     //   checkIn: selection[0].startDate,
//     //   checkOut: selection[0].endDate,
//     // };

//     const body = {
//   roomId: Number(roomId),
//   userId: Number(userId),
//   checkIn: formatDate(selection[0].startDate),
//   checkOut: formatDate(selection[0].endDate),
// };


//     try {
//       const res = await axios.post(
//         "http://localhost:8080/api/booking/book",
//         body
//       );

//       alert("Booking Successful!");
//     } catch (e) {
//       console.error(e);
//       alert("Booking Failed");
//     }
//   };

//   return (
//     <div className="p-6 max-w-3xl mx-auto">
//       <h1 className="text-3xl font-bold mb-6 text-center">Book This Room</h1>

//       {/* --------------------- CALENDAR --------------------- */}
//       <div className="bg-white shadow-md p-4 rounded-xl mb-6">
//         <DateRange
//           editableDateInputs={true}
//           onChange={(item) => setSelection([item.selection])}
//           moveRangeOnFirstSelection={false}
//           ranges={selection}
//           minDate={new Date()}
//         />
//       </div>

//       {/* --------------------- BOOKED DATES WARNING --------------------- */}
//       <p className="text-center text-red-600 text-sm mb-4">
//         ⚠ Already booked dates cannot be used.
//       </p>

//       {/* --------------------- STATUS --------------------- */}
//       {message && (
//         <p
//           className={`text-lg text-center font-semibold mt-4 ${
//             isAvailable ? "text-green-600" : "text-red-600"
//           }`}
//         >
//           {message}
//         </p>
//       )}

//       {/* --------------------- BUTTONS --------------------- */}
//       <div className="flex justify-center gap-4 mt-6">
//         <button
//           onClick={checkAvailability}
//           className="px-6 py-3 bg-blue-600 text-white rounded-lg"
//         >
//           Check Availability
//         </button>

//         {isAvailable && (
//           <button
//             onClick={bookRoom}
//             className="px-6 py-3 bg-green-600 text-white rounded-lg"
//           >
//             Book Now
//           </button>
//         )}
//       </div>
//     </div>
//   ); 
//}

  
//********UI DESIGN FOR BOOKING PAGE 5/1/26 *//

import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { DateRange } from "react-date-range";
import { addDays, isWithinInterval } from "date-fns";
import axios from "axios";
import { useParams } from "react-router-dom";

import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";

const formatDate = (d) => d.toISOString().split("T")[0];

export default function BookingPage() {
  const { roomId } = useParams();
  //const userId = localStorage.getItem("userId");
  const user = JSON.parse(localStorage.getItem("user"));
const userId = user?.id;


  const [selection, setSelection] = useState([
    {
      startDate: new Date(),
      endDate: addDays(new Date(), 1),
      key: "selection",
    },
  ]);

  const [bookedDates, setBookedDates] = useState([]);
  const [isAvailable, setIsAvailable] = useState(null);
  const [message, setMessage] = useState("");

  useEffect(() => {
    axios
      .get(`http://localhost:8080/api/booking/room/${roomId}`)
      .then((res) => {
        setBookedDates(
          res.data.map((b) => ({
            start: new Date(b.checkIn),
            end: new Date(b.checkOut),
          }))
        );
      })
      .catch((err) => console.error(err));
  }, [roomId]);

  const navigate = useNavigate();
const handleCheckAvailability = async () => {
  const user = JSON.parse(localStorage.getItem("user"));

  if (!user) {
    alert("Login first to check availability");
    navigate("/login");
    return;
  }

  const body = {
    roomId: Number(roomId),
    userId: Number(user.id),
    checkIn: formatDate(selection[0].startDate),
    checkOut: formatDate(selection[0].endDate),
  };

  try {
    const res = await axios.post(
      "http://localhost:8080/api/booking/check",
      body
    );
    setIsAvailable(res.data);
    setMessage(res.data ? "Room is available ✔" : "Room is NOT available ❌");
  } catch {
    setMessage("Error checking availability");
  }
};

const bookRoom = async () => {
  const user = JSON.parse(localStorage.getItem("user"));

  if (!user) {
    alert("Please login first");
    navigate("/login");
    return;
  }

  const body = {
    roomId: Number(roomId),
    userId: Number(user.id),
    checkIn: formatDate(selection[0].startDate),
    checkOut: formatDate(selection[0].endDate),
  };

  try {
    await axios.post("http://localhost:8080/api/booking/book", body);
    alert("Booking request sent. Waiting for admin approval.");
  } catch {
    alert("Booking Failed");
  }
};



  // ✅ RETURN MUST BE INSIDE FUNCTION
//   return (
//     <div className="min-h-screen bg-gray-100 py-10 px-4">
//       <div className="max-w-3xl mx-auto bg-white rounded-2xl shadow-xl p-6">

//         <h1 className="text-3xl font-bold text-center mb-6">
//           🏨 Book Your Stay
//         </h1>

//         <div className="bg-gray-50 rounded-xl p-4">
//           <DateRange
//             ranges={selection}
//             onChange={(item) => setSelection([item.selection])}
//             minDate={new Date()}
//           />
//         </div>

//         {message && (
//           <p className={`mt-4 text-center font-semibold ${
//             isAvailable ? "text-green-600" : "text-red-600"
//           }`}>
//             {message}
//           </p>
//         )}

//         <div className="flex justify-center gap-6 mt-8">
//           <button
//             onClick={checkAvailability}
//             className="px-8 py-3 bg-blue-600 text-white rounded-xl"
//           >
//             Check Availability
//           </button>

//           {isAvailable && (
//             <button
//               onClick={bookRoom}
//               className="px-8 py-3 bg-green-600 text-white rounded-xl"
//             >
//               Book Now
//             </button>
//           )}
//         </div>

//       </div>
//     </div>
//   );
// }

return (
  <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 py-10 px-4">
    <div className="max-w-3xl mx-auto bg-white rounded-3xl shadow-2xl p-6 md:p-8">

      <h1 className="text-3xl md:text-4xl font-bold text-center mb-8 text-gray-800">
        🏨 Book Your Stay
      </h1>

      <div className="bg-white rounded-2xl shadow-lg p-4 border border-gray-200">
        <DateRange
          ranges={selection}
          onChange={(item) => setSelection([item.selection])}
          minDate={new Date()}
          rangeColors={["#ed5aed"]}
        />
      </div>

      {message && (
        <p
          className={`mt-6 text-center text-lg font-semibold ${
            isAvailable ? "text-green-600" : "text-red-600"
          }`}
        >
          {message}
        </p>
      )}

      <div className="flex flex-col sm:flex-row justify-center gap-6 mt-10">
        <button
          onClick={handleCheckAvailability}
          className="px-10 py-3 bg-gradient-to-r from-indigo-600 to-blue-600 text-white font-semibold text-lg rounded-full shadow-lg"
        >
          🔍 Check Availability
        </button>

        {isAvailable && (
          <button
            onClick={bookRoom}
            className="px-10 py-3 bg-gradient-to-r from-green-600 to-emerald-600 text-white font-semibold text-lg rounded-full shadow-lg"
          >
            🏨 Book Now
          </button>
        )}
      </div>

    </div>
  </div>
);
}
